import { jsx } from 'react/jsx-runtime';
import { DatadogRumProvider } from '../context/provider.js';

const withDatadogRum = (config)=>(Component)=>{
        const DatadogRumHOC = ()=>{
            if (!config) {
                console.warn('[DatadogRun HOC] Missing config');
                return null;
            }
            return jsx(DatadogRumProvider, {
                ...config,
                children: jsx(Component, {})
            });
        };
        DatadogRumHOC.displayName = 'DatadogRumHOC';
        return DatadogRumHOC;
    };

export { withDatadogRum };
//# sourceMappingURL=hoc.js.map
